// import React from "react";
// import { Card, CardContent, Typography, Grid, IconButton, Box, Divider } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";

// const DashboardCategories = ({ data }) => {
//   // Group by category
//   const grouped = data?.reduce((acc, item) => {
//     const catId = item?.category?.id;
//     if (!acc[catId]) {
//       acc[catId] = {
//         ...item.category,
//         subcategories: [],
//       };
//     }
//     acc[catId]?.subcategories?.push(item);
//     return acc;
//   }, {});

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Grid container spacing={3}>
//         {Object.values(grouped)?.map((category) => (
//           <Grid item xs={12} md={6} lg={4} key={category?.id}>
//             <Card
//               sx={{
//                 borderRadius: 3,
//                 boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//                 transition: "0.3s",
//                 "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.2)" },
//               }}
//             >
//               <CardContent>
//                 <Box display="flex" alignItems="center" justifyContent="space-between">
//                   <Typography variant="h6" fontWeight="bold">
//                     {category?.name}
//                   </Typography>
//                   <IconButton
//                     color="primary"
//                     size="small"
//                     onClick={() => (window.location.href = `/admin/category/${category?.id}/edit`)}
//                   >
//                     <EditIcon />
//                   </IconButton>
//                 </Box>

//                 <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                   {category?.description?.slice(0, 150)}...
//                 </Typography>

//                 <Divider sx={{ my: 1 }} />

//                 <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
//                   Subcategories
//                 </Typography>

//                 {category?.subcategories?.map((sub) => (
//                   <Box
//                     key={sub?.id}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       border: "1px solid #e0e0e0",
//                       borderRadius: 2,
//                       padding: 1,
//                       mb: 1,
//                       backgroundColor: "#f9f9f9",
//                       "&:hover": { backgroundColor: "#f1f1f1" },
//                     }}
//                   >
//                     <Box>
//                       <Typography variant="body1" fontWeight="500">
//                         {sub?.name}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" noWrap>
//                         {sub?.description?.slice(0, 60)}...
//                       </Typography>
//                     </Box>

//                     <IconButton
//                       color="secondary"
//                       size="small"
//                       onClick={() => (window.location.href = `/admin/subcategory/${sub.id}/edit`)}
//                     >
//                       <EditIcon fontSize="small" />
//                     </IconButton>
//                   </Box>
//                 ))}
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default DashboardCategories;


import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Box,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useNavigate } from "react-router";
import SkeletonList from "../../sections/SkeletonList";
import SkeletonCard from "../../sections/SkeletonCard";

const DashboardCategories = ({ data, allCategories = [],isLoading}) => {

  const navigate = useNavigate()
  
  // Step 1: Group subcategories under their parent category IDs
  const grouped = data?.reduce((acc, item) => {
    const cat = item?.category;
    if (!acc[cat?.id]) {
      acc[cat?.id] = {
        ...cat,
        subcategories: [],
      };
    }
    acc[cat?.id].subcategories?.push(item);
    return acc;
  }, {});

  // Step 2: Include categories that might not have any subcategories
  const categoriesWithOrWithoutSubs = allCategories?.map((cat) => {
    return grouped[cat?.id] || { ...cat, subcategories: [] };
  });

  if(isLoading){
    return <SkeletonCard count={1}/>
  }
  return (
    <Box sx={{ padding: 3 }}>
      <Grid container spacing={3}>
        {categoriesWithOrWithoutSubs?.map((category) => (
          <Grid item xs={12} md={6} lg={4} key={category?.id}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                transition: "0.3s",
                "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.2)" },
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography variant="h6" fontWeight="bold">
                    {category?.name}
                  </Typography>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() =>{
                      navigate("/staff/organisation/category/view/",{ state: { category: category,previewCategory:category } })
                    }
                      
                    }
                  >
                    <EditNoteIcon fontSize="small" label="Edit/View"/>
                  </IconButton>
                </Box>

                {category?.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {category?.description?.slice(0, 150)}...
                  </Typography>
                )}

                <Divider sx={{ my: 1 }} />

                {category?.subcategories?.length > 0 ? (
                  <>
                    <Typography
                      variant="subtitle1"
                      fontWeight="medium"
                      sx={{ mb: 1 }}
                    >
                      Subcategories
                    </Typography>

                    {category?.subcategories?.map((sub) => (
                      <Box
                        key={sub.id}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #e0e0e0",
                          borderRadius: 2,
                          padding: 1,
                          mb: 1,
                          backgroundColor: "#f9f9f9",
                          "&:hover": { backgroundColor: "#f1f1f1" },
                        }}
                      >
                        <Box>
                          <Typography variant="body1" fontWeight="500">
                            {sub?.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            noWrap
                          >
                            {sub?.description?.slice(0, 60)}...
                          </Typography>
                        </Box>

                        <IconButton
                          color="secondary"
                          size="small"
                          onClick={() =>{
                            navigate("/staff/organisation/subcategory/view/",{ state: { subcategory: sub,previewSubCategory:sub,id:category?.id } })
                          }
                          }
                        >
                          <EditNoteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1, fontStyle: "italic" }}
                  >
                    No subcategories yet.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashboardCategories;
